// extracted by mini-css-extract-plugin
export default {"pageHeader":"pageHeader__qWHJ8","contextHolder":"contextHolder__wdU85","context":"context__kanlr"};